import React from 'react'
import styled from 'styled-components'

import { FaPlay } from 'react-icons/fa'
import { AnimatePresence, motion } from "framer-motion"

const defaultStyle = {
    padding: '0.5rem',
    fontSize: '0.7rem',
    backgroundColor: 'var(--secondary-color)',
    color: 'var(--text-color)'
}

const Icon = styled.div`
    padding: ${props => props.styles.padding};
    border-radius: 5px;
    font-size: ${props => props.styles.fontSize};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.styles.backgroundColor};
    color: ${props => props.styles.color};
    :hover {
        filter: brightness(var(--brightness));
    };
`

const ToggleButton = props => {
    const {
        open,
        onSelect,
        styles,
        icon,
        start,
        end,
        alignment
    } = props
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    return (
        <div style={{alignSelf: alignment || 'start'}}>
            <AnimatePresence initial={false}>
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    positionTransition
                    animate={{ rotate: open ? end || 90 : start || 0}}
                    transition={{ duration: 0.2 }}>
                        <Icon styles={updatedStyle} open={open} onClick={onSelect}>{icon || <FaPlay/>}</Icon>
                </motion.div>
            </AnimatePresence>
        </div>
    )
}

export default ToggleButton